import { Question } from './interfaces/components';

export const AudioModal = {
  en: {
    text: 'Would you like to enable audio?',
    yes: 'Yes',
    no: 'No',
  },
  ar: {
    text: 'هل ترغب في تفعيل الصوت',
    yes: 'نعم',
    no: 'كلا',
  },
};

export const OverlayMenu = {
  en: {
    instructions: 'Instructions',
  },
  ar: {
    instructions: 'التعليمات',
  },
};

export const PDPContent = {
  en: {
    collection: 'Collection',
    addToCart: 'Add To Cart',
    santaWishlist: 'Santa Wishlist',
    quantity: 'ml',
    currency: 'AED',
    addedToWishlist: 'Item added to wishlist',
    addedToWishlistAlready: 'Already in wishlist',
  },
  ar: {
    collection: 'مجموعة',
    addToCart: 'أضف إلى الحقيبة',
    santaWishlist: 'قائمة أمنيات سانتا',
    quantity: 'مل',
    currency: 'د.إ',
    addedToWishlist: 'تمت إضافة المنتج إلى قائمة الأمنيات',
    addedToWishlistAlready: 'المنتج موجود بالفعل في قائمة الرغبات',
  },
};

export const ArabicIngredients = {
  Lavender: 'لافندر',
  Immortelle: 'إمورتيل',
  Almond: 'اللوز',
  Shea: 'زبدة الشيا',
};

export const ProductComingSoon = {
  en: {
    title: 'Product Coming Soon',
    description: 'Stay tuned and return later to discover these skincare treasures from L’Occitane!',
  },
  ar: {
    title: 'المنتج قريبا',
    description: 'ابق على اتصال وارجع لاحقًا لاكتشاف كنوز العناية بالبشرة هذه من L’Occitane!',
  },
};

export const HydratingSkinModal = {
  en: {
    textOne: 'OUR WELLBEING TIPS',
    textTwo: 'Keep Your Skin Hydrated',
    textThree: 'Stay hydrated by drinking plenty of water between Iftar and Suhoor.',
    textFour:
      'Follow a gentle, moisturising skincare routine using our Shea Butter collection to keep your skin hydrated throughout the fasting hours.',
  },
  ar: {
    textOne: 'نصائح لصحة أفضل',
    textTwo: 'الحفاظ على رطوبة البشرة',
    textThree: 'شرب الكثير من الماء بين الإفطار والسحور لتجنب الجفاف',
    textFour: 'روتين عناية بالبشرة لطيف ومرطّب باستخدام مجموعة زبدة الشيا للحفاظ على ترطيب بشرتك خلال ساعات الصيام',
  },
};

export const RamadanSpiritModal = {
  en: {
    textOne: 'OUR WELLBEING TIPS',
    textTwo: 'Share The Love, Feel the Ramadan Spirit',
    textThree:
      'Gift your loved ones thoughtful gifts from our exclusive Ramadan collection.  Immerse them in the essence of well-being with our limited-edition gift sets and calendar.',
    textFour:
      'Elevate your gifting experience, and let each present be a token of love and serenity during this blessed month.',
  },
  ar: {
    textOne: 'نصائح لصحة أفضل',
    textTwo: 'شارك المحبة لتشعر بروح رمضان',
    textThree:
      'قدم لأحبائك هدايا مبتكرة من مجموعتنا الحصرية لرمضان. اغمرهم في جوّ الرفاهية مع أطقم الهدايا ورزنامة الجمال ذات الإصدار المحدود',
    textFour: 'ارتق بتجربة الهدايا الخاصة بك ولتكن كل هدية رمزًا للحب والسكينة في هذا الشهر المبارك',
  },
};

export const YourBodyModal = {
  en: {
    textOne: 'OUR WELLBEING TIPS',
    textTwo: 'Listen To Your Body',
    textThree:
      'Keep your skin healthy with regular exercise for improved circulation and stress management, preventing issues like acne and eczema.',
    textFour: 'Finish with a warm shower using our Almond Collection for a delightful scent.',
  },
  ar: {
    textOne: 'نصائح لصحة أفضل',
    textTwo: 'استمع إلى إحتياجات الجسم',
    textThree:
      'احرص على صحة بشرتك من خلال ممارسة الرياضة بانتظام لتحسين الدورة الدموية وتقليل التوتر، مما يساعد في الوقاية من مشاكل البشرة مثل حب الشباب والإكزيما',
    textFour: 'انهي يومك بالاستحمام بالماء الدافئة باستخدام مجموعة اللوز لرائحة لذيذة، منعشة ومريحة',
  },
};

export const SpreadJoyModal = {
  en: {
    textOne: 'Spread the Joy with a Friend',
    textTwo: 'Invite a friend to L’Occitane Ramadan Experience',
    textThree: '& get 10% OFF products in the experience for both of You.',
    textFour: 'share to reveal code',
    textFourSucc: 'ram10',
    button: 'share',
    copied: 'Copied',
  },
  ar: {
    textOne: 'انشر الفرحة مع صديق',
    textTwo: 'ادعو صديقاً لتجربة رمضان واحصلوا على خصم',
    textThree: '10٪ على المنتجات المختارة في التجربة',
    textFour: 'شارك التجربة لتحصل على كود الخصم',
    textFourSucc: 'ram10',
    button: 'شارك',
    copied: 'نجاح منسوخ',
  },
};

export const StartingRoomModal = {
  en: {
    start: 'Where would you like to start:',
    terrace: {
      textOne: 'Terrace',
      textTwo: 'Ramadan Skincare Quiz',
      textThree: 'Our Iconic Products',
      textFour: 'Wellbeing Tips',
      button: 'Go',
    },
    indoor: {
      textOne: 'Indoor',
      textTwo: 'Ramadan Advent Calendar',
      textThree: 'Limited Editions Gifts',
      textFour: 'Wellbeing Tips',
      button: 'Go',
    },
  },
  ar: {
    start: ':من أين تريد أن تبدأ',
    terrace: {
      textOne: 'تراس',
      textTwo: 'أسئلة للعناية بالبشرة في رمضان',
      textThree: 'منتجاتنا الأيقونية',
      textFour: 'نصائح لصحة أفضل',
      button: 'ابدأ',
    },
    indoor: {
      textOne: 'داخل المنزل',
      textTwo: 'رزنامة الجمال الرمضانية ',
      textThree: 'هدايا محدودة الإصدار',
      textFour: 'نصائح لصحة أفضل',
      button: 'ابدأ',
    },
  },
};

export const IllustrationModal = {
  en: {
    textOne: 'OUR WELLBEING TIPS',
    textTwo: 'Illustrated by Bayan Yasien',
    textThree: `"Behind each door there's a story"`,
    textFour: `This concept is inspired by the spirit of Ramadan in Arab countries. The essence of this project revolves around warm feelings, love, security, and shared moments.`,
  },
  ar: {
    textOne: 'نصائح لصحة أفضل',
    textTwo: 'رسم بيان ياسين',
    textThree: '"وراء كل باب قصة"',
    textFour:
      '.هذه الفكرة مستوحاة من مظاهر رمضان في البلدان العربية، جوهر هذا العمل هي المشاعر الدافئة، الحب، الأمان والمشاركة',
  },
};

export const QualitySleepModal = {
  en: {
    textOne: 'OUR WELLBEING TIPS',
    textTwo: 'Prioritize Quality Sleep',
    textThree:
      'Light the Relaxing Candle to fill the room with the calming scents of Lavender, Sweet Orange, and Geranium.',
    textFour: 'Shop Now',
  },
  ar: {
    textOne: 'نصائح لصحة أفضل',
    textTwo: 'اهتم بجودة نومك',
    textThree: 'اشعل الشمعة المعطرة للاسترخاء لملء الغرفة بعبير اللافندر والبرتقال الحلو وزهرة الجيرانيوم المهدئة. ',
    textFour: 'تسوق الآن',
  },
};

export const RestfulEnvironmentModal = {
  en: {
    textOne: 'OUR WELLBEING TIPS',
    textTwo: 'Make your bedroom a restful environment',
    textThree:
      'Before heading to bed with the Cocon de Sérénité Relaxing Pillow Mist. Spritz around your bedroom to create a calming atmosphere.',
    textFour: 'Shop Now',
  },
  ar: {
    textOne: 'نصائح لصحة أفضل',
    textTwo: 'حوِّل غرفتك إلى مكان هادئ ومريح',
    textThree: 'قم برش الرذاذ المهدئ على الوسادة قبل الاستعداد للنوم لخلق جو هادئ ومريح في الغرفة.',
    textFour: 'تسوق الآن',
  },
};

export const SleepingBeautyModal = {
  en: {
    textOne: 'OUR WELLBEING TIPS',
    textTwo: 'Sleeping Beauty - Reset Your Skin',
    textThree:
      "Revitalize your complexion with our Overnight Reset Serum. It awakens your skin's genes, provides antioxidants, and relaxes facial muscles for a stress-free glow in the morning.",
    textFour: 'Shop Now',
  },
  ar: {
    textOne: 'نصائح لصحة أفضل',
    textTwo: 'إعادة إحياء البشرة ليلاً',
    textThree:
      'استخدم سيروم إمورتيل ريسيت للإصلاح الليلي لإعادة إحياء البشرة. يساعد هذا السيروم على إحياء جينات بشرتك، ويوفر مضادات الأكسدة، كما أنه يفك تشنج عضلات الوجه لبشرة مشرقة ونضرة صباحاً.',
    textFour: 'تسوق الآن',
  },
};

export const questions: Question[] = [
  {
    index: 0,
    question: 'What is your major skin concern?',
    questionAR: 'ما هي مشكلة بشرتك الرئيسية؟',
    answers: [
      { text: 'Enlarged pores', productId: '27SE075I22' },
      { text: 'FINE LINES', productId: '27DC050I23' },
      { text: 'Dullness', productId: '27OR030I21' },
    ],
    answersAR: [
      { text: 'مسام واسعة', productId: '27SE075I22' },
      { text: 'خطوط دقيقة', productId: '27DC050I23' },
      { text: 'بهتان', productId: '27OR030I21' },
    ],
  },
  {
    index: 1,
    question: 'What do you need to enhance your face care routine?',
    questionAR: 'ماذا تحتاج لتعزيز روتين العناية بالبشرة؟',
    answers: [
      { text: 'Double Cleansing', productId: '27MC125I23' },
      { text: 'Hydration', productId: '01CV050K22' },
      { text: 'Regeneration', productId: '27OR030I21' },
    ],
    answersAR: [
      { text: 'تنظيف مزدوج', productId: '27MC125I23' },
      { text: 'ترطيب', productId: '01CV050K22' },
      { text: 'تجديد خلايا البشرة ', productId: '27OR030I21' },
    ],
  },
  {
    index: 2,
    question: 'What do you need to enhance your body care routine?',
    questionAR: 'ماذا تحتاج لتعزيز روتين العناية بجسمك؟',
    answers: [
      { text: 'Moisturization & Nourishment', productId: '01BK150K0' },
      { text: 'Suppleness', productId: '29HS100A21' },
      { text: 'Firmness', productId: '29LC200A22' },
    ],
    answersAR: [
      { text: 'ترطيب وتغذية', productId: '01BK150K0' },
      { text: 'مرونة', productId: '29HS100A21' },
      { text: 'شد', productId: '29LC200A22' },
    ],
  },
  {
    index: 3,
    question: 'What is your preferred scent?',
    questionAR: 'ما هي الرائحة التي تفضلها؟',
    answers: [
      { text: 'Spicy and warm scents', productId: '11EP090A20' },
      { text: 'Vibrant and invigorating fragrances', productId: '12ET075NO22' },
      { text: 'Willing to try something new', productId: '11EDT50H24' },
    ],
    answersAR: [
      { text: 'روائح حارة ودافئة', productId: '11EP090A20' },
      { text: 'روائح أنيقة ومنعشة', productId: '12ET075NO22' },
      { text: 'أودّ أن أجرب رائحة جديدة', productId: '11EDT50H24' },
    ],
  },
];

export const QuizContent = {
  en: {
    top: 'Build Your Ramadan Routine',
    result: 'Results',
    text: 'Based on your preferences we recommend these products:',
    learnMore: 'LEARN MORE',
    addToCart: 'ADD TO CART',
    shopAll: 'SHOP ALL',
    retake: 'Retake Quiz',
    prev: 'PREVIOUS QUESTION',
  },
  ar: {
    top: 'اكتشف الروتين الذي يناسبك في رمضان',
    result: 'النتائج',
    text: ':بناءً على أجوبتك ننصحك باستخدام هذه المنتجات',
    learnMore: 'اكتشف المزيد',
    addToCart: 'أضف إلى حقيبة التسوق',
    shopAll: 'تسوق الروتين كاملاً ',
    retake: 'إعادة الإختبار',
    prev: 'السؤال السابق',
  },
};

export const RoseContent = {
  en: {
    title: 'Rose',
    text: 'Rose Eau de Toilette captures the essence of the iconic rose flower in a dazzling, elegant, feminine and resolutely modern fragrance.',
  },
  ar: {
    title: 'الورد',
    text: 'أو دو تواليت الورد يجسد جوهر زهرة الورد الأسطورية بطابع ساحر، وأنيق، وأنثوي، وعصري.',
  },
};

export const PivoineFloraContent = {
  en: {
    title: 'Pivoine Flora',
    text: 'This fragrance is rich and floral, like a bouquet of freshly-picked peonies. It begins with fresh citrus notes and finishes with a base of white musk and sandalwood.',
  },
  ar: {
    title: 'بيفوان فلورا',
    text: 'عطر زهري غني بزهور البيوني الطازجة. يحتوي على نفحات منعشة من الحمضيات، والمسك الأبيض والصندل.',
  },
};

export const NeroliOrchideeContent = {
  en: {
    title: 'Néroli & Orchidée',
    text: 'A tantalizing and lovely fragrance, Néroli & Orchidée blends the scents of two precious flowers orange blossom and white orchid in a beautiful harmony.',
  },
  ar: {
    title: 'نيرولي وأوركيد',
    text: 'استمتع بعطر نيرولي وأوركيد، الذي يجمع بين عبير زهرة البرتقال ونفحات زهرة الأوركيد البيضاء بتناغم جميل وجذاب.',
  },
};

export const MenCollectionContent = {
  en: {
    title: 'Men Collection',
    text: 'With energising scents like cade and citron, we take personal grooming to a new level so you can look and smell great with the power of nature.',
  },
  ar: {
    title: 'للرجال',
    text: 'اختاروا روتين عناية شخصية كامل للرجال مع روائح منعشة مثل الكاد والسيترون.',
  },
};

export const CherryBlossomContent = {
  en: {
    title: 'Cherry Blossom',
    text: 'One of the sweetest scents, cherry blossom combines  soft floral notes with the slight tart undercurrent of cherry fruit, leaving a warm and delicate scent on the skin.',
  },
  ar: {
    title: 'زهرة الكرز',
    text: 'زهرة الكرز  هي من ألطف الروائح تمزج بين نفحات الزهور الناعمة مع لمسة خفيفة من فاكهة الكرز، مما يترك رائحة دافئة ورقيقة على البشرة.',
  },
};

export const ArlesienneContent = {
  en: {
    title: 'Arlésienne',
    text: 'This fragrance is distinctly floral, unfolding like a bouquet of flowers with a musky undertone. It leaves a captivating trail that embodies both tender innocence and hypnotic sensuality.',
  },
  ar: {
    title: 'آرليزيان',
    text: 'هذا العطر زهري بشكل مميز، ينبثق كباقة من الزهور مع لمسة مسكية. يترك البشرة برائحة رقيقة وجذّابة.',
  },
};

export const WhiteLavenderContent = {
  en: {
    title: 'White Lavender',
    text: 'A twist on the traditional lavender scent, reminiscent of freshly washed linen. This delicate fragrance starts with citrusy bergamot and cedrat, leading to a floral heart of white lavender, white rose, and blackcurrant.',
  },
  ar: {
    title: 'اللافندر الأبيض',
    text: 'هذه الرائحة الفريدة تعتبر تحولاً عصرياً لرائحة اللافندر التقليدية، تذكرنا برائحة ناعمة ومنعشة. يحتوي هذا العطر على رائحة حمضية من البرغموت والسدرات، ونفحات زهرية غنية باللافندر الأبيض والورد الأبيض والتوت الأسود.',
  },
};

export const EauDIparieContent = {
  en: {
    title: "Eau D'Iparie",
    text: 'An opulent, sensual fragrance infused with patchouli, musk and myrrh with rose and peony.',
  },
  ar: {
    title: 'إيباري',
    text: 'عطر فاخر يحتوي على الباتشولي والمسك، مع نفحات من الورد والبيوني.',
  },
};

export const AmbreContent = {
  en: {
    title: 'Ambre',
    text: 'A captivating opulent fragrance that combines the sweetness of vanilla with a bouquet of bergamot, freesia, and cedar.',
  },
  ar: {
    title: 'العنبر',
    text: 'عطر فاخر وجذاب يمزج بين حلاوة الفانيليا ونفحات البرغموت، والفريزيا.',
  },
};

export const VerbenaContent = {
  en: {
    title: 'Verbena',
    text: 'Among all the aromatic herbs that grow along the paths of Provence, there is one whose lemony freshness helps revive the body and mind: the Verbena.',
  },
  ar: {
    title: 'فربينا',
    text: 'في بروفانس، تنمو العديد من الأعشاب العطرية على جوانب الطرق، ولكن هناك نبتة تتميز برائحتها المنعشة التي تساعد على تنشيط الجسم والعقل، وهي نبتة الفيربينا.',
  },
};

export const Intense86Content = {
  en: {
    title: '86 Intense',
    text: 'Exclusively crafted for the Middle East, featuring unique blends inspired by the warmth of the region.',
  },
  ar: {
    title: '٨٦ إنتنس',
    text: 'مجموعة حصرية لمنطقة الشرق الأوسط، تتميز  بنفحات عربية فريدة ومميزة.',
  },
};

export const NeroliOrchideeBestSellerModalContent = {
  en: {
    title: 'Néroli & Orchidée',
    text: 'An alluring and captivating fragrance, created by a harmonious blend of radiant neroli essence and delicate white orchid.',
    subTitle: 'For a long lasting scent, layer it with:',
    product1: {
      title: 'Néroli & Orchidée Hand Cream',
      size: '30ml',
      price: '39 AED',
    },
    product2: {
      title: 'Néroli & Orchidée Body Milk',
      size: '',
      price: '139 AED',
    },
  },
  ar: {
    title: 'نيرولي وأوركيد',
    text: 'عطر جذاب ومثير، يتميز بمزيج من زهرة النيرولي وزهرة الأوركيد البيضاء.',
    subTitle: 'لرائحة تدوم طويلاً، استخدام العطر مع:',
    product1: {
      title: 'كريم اليدين نيرولي وأوركيد',
      size: '30ml',
      price: '39 AED',
    },
    product2: {
      title: 'حليب الجسم من نيرولي وأوركيد',
      size: '30ml',
      price: '39 AED',
    },
  },
};

export const WelcomeContent = {
  en: {
    title: 'Fragrance Garden',
    subTitle: 'Online exclusive experience',
    description: 'Rediscover iconic fragrances for both women & men, expertly crafted by our Perfumers.',
  },
  ar: {
    title: 'حصرياً أونلاين',
    subTitle: 'حديقة العطور',
    description: 'اكتشف من جديد العطور الأيقونية للنساء والرجال، المبتكرة بمهارة عالية على يد عطارين محترفين.',
  },
};
